import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { persistor, store } from '@zonofi/zono-money-store';
import { PersistGate } from 'redux-persist/integration/react';
import { AppNavigator } from '../navigation';
import './fonts.css';
import './app.scss';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { firebaseConfig } from '../firebase.config';
import { i18nService } from '@zonofi/i18n';

// Firebase setup for web
globalThis.sellerFirebaseApp = initializeApp(firebaseConfig);
globalThis.sellerFirebasedb = getFirestore(globalThis.sellerFirebaseApp);

export function App() {
  useEffect(() => {
    if (!i18nService.isInitialized()) i18nService.initialize({});
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppNavigator />
      </PersistGate>
    </Provider>
  );
}

export default App;
